import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import './BillList.css'; // Custom styles for the receipt
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import {formatReceiptData} from '../components/ReceiptData';
import axios from "axios";
import { message } from 'antd';
import Swal from 'sweetalert2';
import config from "../config";
 
const OrderReceipt = forwardRef(({ orders, tableNumber, selectedOrders = [] },ref) => {
    const apiBaseUrl = config.REACT_APP_API_BASE_URL;

    const navigate = useNavigate();
    const [currentUser, setCurrentUser] = useState(null);
    // const [itemsData, setItemsData] = useState([]);
    const [orderItems, setOrderItems] = useState([]);
    const [orUserId, setUserId] = useState("");
      
    const [loading, setLoading] = useState(false);
      const [restaurantName, setRestaurantName] = useState(null);
      const [imageLogo, setImageLogo] = useState(null);
      const [restaurantAddress, setRestaurantAddress] = useState(null);
      const [totalQuantity, setTotalQuantity] = useState(0);
    const [isSendSeperatedOrderChit,setIsSendSeperatedOrderChit] = useState(false);

    // console.log("Orders:", orders);
    // console.log("Selected Orders:", selectedOrders);

    const getSetting = async () => {
        setLoading(true);
        try {
          const { data } = await axios.get(`${apiBaseUrl}/api/settings/get-settings`);

            console.log("Settings Data:", data);

          setIsSendSeperatedOrderChit(data.isSendSeperatedOrderChit);
          
          if (data && data.image) {
            setImageLogo(data.image);
            setRestaurantName(data.name);
            setRestaurantAddress(data.address);
          } else {
            setImageLogo("https://bucketergroup.s3.ap-southeast-1.amazonaws.com/posfolder/logo.png");
            setRestaurantName("Klang Bak Kut Teh");
            setRestaurantAddress("xxx")
          }
        } catch (error) {
        //   message.error("Something Went Wrong");
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Something Went Wrong',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            });
        }finally{
            setTimeout(() => setLoading(false), 1000);
        }
      };
    
      useEffect(() => {
        getSetting();
        // fetchInvoiceData(invoiceId);
      }, []);

      useEffect(() => {
        let selected = orders
            .filter((order) => selectedOrders.includes(order.oid))
              .flatMap((order) =>
                  Array.isArray(order.order_items)
                      ? order.order_items.map(item => ({ ...item, orUserId: order.orUserId }))
                      : []
              );
          console.log('selected in line 70: ', selected);

        
        const selectedSingleRecord=JSON.parse(localStorage.getItem('selectedSingleRecord'));
        if(selectedSingleRecord){
            console.log('selectedSingleRecord in line 73: ',selectedSingleRecord);
            selected=selected.filter(product=>product._id==selectedSingleRecord._id);
        }
        setOrderItems(selected);
    
        // Log the total quantity here
        console.log("Total Quantity:", selected.reduce((sum, item) => sum + item.quantity, 0));
    }, [orders, selectedOrders]);
    
    

    useEffect(() => {
        const auth = JSON.parse(localStorage.getItem('auth'));
        if (auth) {
            const { token } = auth;
            try {
                const decoded = jwtDecode(token);
                setCurrentUser(decoded.userId);
                if (window.location.pathname === '/login') {
                    navigate('/');
                }
            } catch (err) {
                console.error('Invalid token', err);
                localStorage.removeItem('auth');
                navigate('/login');
            }
        } else {
            navigate('/login');
        }
    }, [navigate]);

    // Get selected order items
    useEffect(() => {

        let selected = orders
            .filter((order) => selectedOrders.includes(order.oid))
            .flatMap((order) =>
                Array.isArray(order.order_items)
                    ? order.order_items.map(item => ({ ...item, orUserId: order.orUserId }))
                    : []
            );
        const selectedSingleRecord=JSON.parse(localStorage.getItem('selectedSingleRecord'));
        if(selectedSingleRecord){
            console.log('selectedSingleRecord in line 105: ',selectedSingleRecord);
            selected=selected.filter(product=>product._id==selectedSingleRecord._id);
        }
        setOrderItems(selected);
        // console.log("Selected Order:", selected)
    }, [orders, selectedOrders]);


    // const getAllItems = async () => {
    //     try {
    //         const { data } = await axios.get(`${apiBaseUrl}/api/products/get-product`);
    //         setItemsData(data);
    //         // console.log("this print",data);
    //     } catch (error) {
    //         console.log(error);
    //     }
    // };

    // Fetch items when the component mounts
    // useEffect(() => {
    //     getAllItems();
    // }, []);

    useEffect(() => {
        let selected = orders
            .filter((order) => selectedOrders.includes(order.oid))
            .flatMap((order) => Array.isArray(order.order_items) ? order.order_items.map(item => ({
                    ...item,
                selectedOrder: order.oid, // add the orderid to each item
                orUserId: order.orUserId // add the orUserId to each item
                }))
            
            : []);

        console.log('selected in line 143: ',selected);
        
        const selectedSingleRecord=JSON.parse(localStorage.getItem('selectedSingleRecord'));
        if(selectedSingleRecord){
            console.log('selectedSingleRecord in line 146: ',selectedSingleRecord);
            selected=selected.filter(product=>product._id==selectedSingleRecord._id);
        }
        setOrderItems(selected);
    
        // Calculate and set the total quantity
        const quantity = selected.reduce((sum, item) => sum + item.quantity, 0);
        setTotalQuantity(quantity);
    }, [orders, selectedOrders]);

    // Function to get category name by product ID
    // const getProductCategory = (productId) => {
    //     const product = itemsData.find(item => item._id === productId);
    //     return product ? product.category : 'Unknown Category';
    // };

    useImperativeHandle(ref, () => ({
            printOrderReceipt: async () => {
                const selectedSingleRecord=JSON.parse(localStorage.getItem('selectedSingleRecord'));
                if(selectedSingleRecord){
                    const result = handlePrintSlug();
                    return result;
                }else{
                     await handlePrint();
                    console.log("Printing order receipt with items:", orderItems);
                    console.log("isSendSeperatedOrderChit:", isSendSeperatedOrderChit);
                    //by default seperate order chit, can be controlled by settings in future
                    //if false then will not run function below
                    if(isSendSeperatedOrderChit){
                        const result = handlePrintSlug();
                        return result;
                    }
                }
            },
    }));

    const handlePrint = async () => {

        try {

            console.log("Order Items:", orderItems);

            const receiptData = formatReceiptData(
                orderItems,imageLogo,
                restaurantName,
                restaurantAddress,
                currentUser, tableNumber,
                selectedOrders,
                isSendSeperatedOrderChit);
            
            const response = await axios.post(`${apiBaseUrl}/api/printorderreceipt`,
                receiptData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        // Add any authentication headers if needed
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('auth')).token}`
                    }
                }
            );

            if (response.data.success) {
                // alert('Receipt sent to printer successfully!');
                Swal.fire({
                    title: 'Success',
                    text: 'Receipt sent to printer successfully!',
                    icon: 'success',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                });
                return true;
            } else {
                throw new Error(response.data.message || 'Printing failed');
            }
        } catch (error) {
            // alert('Failed to print receipt: ' + (error.response?.data?.message || error.message));
            Swal.fire({
                icon: 'error',
                title: 'Print Error',
                text: 'Failed to print receipt: ' + (error.response?.data?.message || error.message),
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            });
            return false;
        }

        // const printWindow = window.open('', '', 'width=600,height=400');
        // const printContent = document.getElementById('printable-order-receipt').innerHTML;

        // printWindow.document.write(`
        //     <html>
        //         <head>
        //             <title>Print Order Chit</title>
        //             <style>
        //                 @media print {
        //                     body {
        //                         margin: 0;
        //                         padding: 0;
        //                         width: 80mm;
        //                         height: auto;
        //                          overflow: hidden;
        //                         font-family: Arial, sans-serif;
        //                         page-break-after: always;
        //                         // line-height: 1.5;
        //                     }

        //                     .print-header {
        //                         display: none; /* This will hide the header */
        //                     }
                            
        //                     .receipt-container {
        //                         max-width: 58mm;
        //                         margin: 0;
        //                         padding: 0;
        //                     }
        //                     table {
        //                         width: 100%;
        //                         border-collapse: collapse;
        //                     }
        //                     th, td {
        //                         border: none;
        //                         padding: 5px;
        //                         text-align: left;
        //                     }
                                
        //                 }
        //             </style>
        //         </head>
        //         <body>
        //             ${printContent}
        //         </body>
        //     </html>
        // `);

        // printWindow.document.close();
        // printWindow.focus();
        // printWindow.print();

        // setTimeout(() => {
        //     printWindow.close();
        // }, 500);
    };


    
    const handlePrintSlug = async () => {
    try {
        console.log("Order Items:????", orderItems);

            
            const receiptData = formatReceiptData(
                orderItems,
                imageLogo,
                restaurantName,
                restaurantAddress,
                currentUser,
                tableNumber,
                isSendSeperatedOrderChit
            );

            console.log("receiptData:", receiptData);

            const response = await axios.post(`${apiBaseUrl}/api/printorderreceiptslug`,
                receiptData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('auth')).token}`
                    }
                }
            );

            console.log("Response from print slug:", response.data);
            if (response.data.success) {
                console.log("Print result:", response.data.printResult);
                Swal.fire({
                    title: 'Success',
                    text: 'Order receipt sent to printer successfully!',
                    icon: 'success',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                });
                return true;
            } else {

            console.error("Print error:", response.data.printResult);

                await Swal.fire({
                    icon: 'error',
                    title: 'Print to these printers failed',
                    text: Array.isArray(response.data.printResult)
                        ? response.data.printResult
                            .map(err =>
                                typeof err === 'object' && err.group
                                    ? `Printer group: ${err.group}`
                                    : typeof err === 'string'
                                        ? err
                                        : JSON.stringify(err)
                            )
                            .join('\n')
                        : response.data.printResult || 'Printing failed',
                    showConfirmButton: true,
                }).then(() => {
                    return false;
                });
            }
            
    } catch (error) {
        console.log("Error during print slug:", error);
        Swal.fire({
            icon: 'error',
            title: 'Print Error',
            text: 'Failed to process print request: ' + (error.response?.data?.message || error.message),
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
        });
    }
};



    if (!orderItems.length) {
        return <div>No orders pending for kitchen.</div>;
    }

    

    // const formatReceiptData = () => {
       
    //     return {
    //         logo: imageLogo,
    //         resName: restaurantName,
    //         address: restaurantAddress,
    //         cashierName: currentUser,
    //         orders: orderItems.map(item => ({
    //             quantity: item.quantity,
    //             product: {
    //                 name: item.product.name,
    //                 category: item.product.category
    //             },
    //                 addOns: item.product.addOns.map((addOn) => ({
    //                     id: addOn.id,
    //                     name: addOn.name,
    //                     price: addOn.price,
    //                     group: addOn.group,
    //                 })) || [],
    //                 remarks: item.remarks || ''
    //         })),
    //         tableNumber: String(tableNumber),
    //         selectedOrders,
    //         totalItems: totalQuantity,
    //     };
       
    //   };


      
    
     
    return (
        <div>
            <div id="printable-order-receipt" className="receipt-container">
                <div className="receipt-header">
                    <p style={{ fontSize:"15px", height:"8px", textAlign:"center" }}><strong>** Order Chit **</strong></p>
                    <p style={{ fontSize:"15px", height:"8px", textAlign:"left" }}><strong>Table Number:</strong> {tableNumber}</p>
                    <p style={{ fontSize:"12px", height:"8px", textAlign:"left" }}><strong>Date:</strong> {new Date().toLocaleString()}</p>
                    <p style={{ fontSize:"12px", height:"8px", textAlign:"left" }}><strong>Cashier Name: </strong>{currentUser}</p>
                    <p style={{ fontSize:"12px", height:"8px", textAlign:"left" }}> </p>
                    
                    <div style={{ fontSize: "12px", textAlign: "left", wordBreak: "break-word", whiteSpace: "normal", overflowWrap: "break-word" }}>
                        <strong style={{ display: "inline-block", marginBottom: "4px" }}>Order Id:</strong>
                        <span style={{ marginLeft: "15px" }}>
                            {selectedOrders.map(orderId => orderId.substring(7)).join(', ')}
                        </span>
                    </div>
                    
                    <p></p>
                </div>

                {/* Render the orders that are not Drinks */}
                <table className="receipt-table">
                {/* Food Table */}
                {orderItems.filter(item => item.product.category !== "Drinks").length > 0 && (
                    <>
                    <thead>
                        <tr style={{ borderTop: "1px solid #ddd" }}>
                        <th style={{ width: "50px" }}>Qty</th>
                        <th>Food(s)</th>
                        </tr>
                    </thead>
                    <tbody style={{ borderTop: "1px solid #ddd" }}>
                    {Object.values(
                    orderItems
                        .filter(item => {
                        const isFood = item.product.category !== "Drinks";
                        // console.log("Filtering food items:", { item, isFood });
                        return isFood;
                        })
                        .reduce((acc, item) => {
                        // Group addOns by their group name
                        const groupedAddOns = item.product.addOns
                            ? item.product.addOns.reduce((groupAcc, addOn) => {
                                if (!groupAcc[addOn.group]) {
                                groupAcc[addOn.group] = [];
                                }
                                groupAcc[addOn.group].push(addOn.name);
                                return groupAcc;
                            }, {})
                            : {};

                        // Serialize grouped addOns for comparison
                        const addOnsKey = Object.entries(groupedAddOns)
                            .sort(([groupA], [groupB]) => groupA.localeCompare(groupB)) // Sort groups alphabetically
                            .map(([group, names]) => `${group}:${names.sort().join(",")}`) // Sort and join names in each group
                            .join("|"); // Join groups with "|"

                        // Generate a unique key based on product attributes
                        const key = `${item.product.name}__${item.remarks || "__no_remark__"}__${addOnsKey}`;
                        // console.log("Generated key:", { key, item });

                        if (!acc[key]) {
                            acc[key] = {
                            ...item,
                            quantity: item.quantity, // Start with the item's quantity
                            };
                        } else {
                            // Merge quantities
                            acc[key].quantity += item.quantity;
                        }
                        return acc;
                        }, {})
                    ).map((group, index) => (
                    <React.Fragment key={index}>
                        <tr>
                        <td style={{ width: "50px" }}>{group.quantity}</td>
                        <td>{group.product.name}</td>
                        {/* <td >[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;]</td> */}
                        <td style={{textAlign: "center"}}>[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;]</td>
                        {/* <td></td> */}
                        </tr>
                        {(group.remarks || (Array.isArray(group.product.addOns) && group.product.addOns.length > 0)) && (
                        <tr>
                            <td></td>
                            <td colSpan={2}>
                            <ul style={{ paddingLeft: "20px", margin: 0, listStyleType: "none", fontStyle: "italic" }}>
                                {Array.isArray(group.product.addOns) && group.product.addOns.length > 0 && (
                                Object.entries(
                                    group.product.addOns.reduce((acc, addOn) => {
                                    if (!acc[addOn.group]) {
                                        acc[addOn.group] = [];
                                    }
                                    acc[addOn.group].push(addOn.name);
                                    return acc;
                                    }, {})
                                ).map(([groupName, addOnGroup], idx) => (
                                    <li key={idx}>- {groupName}: {addOnGroup.join(", ")}</li>
                                ))
                                )}
                                {group.remarks && <li>- Remark: {group.remarks}</li>}
                            </ul>
                            </td>
                        </tr>
                        )}
                    </React.Fragment>
                    ))}
                    </tbody>
                    </>
                )}

                {/* Drinks Table */}
                {orderItems.filter(item => item.product.category === "Drinks").length > 0 && (
                <>
                    <thead>
                    <tr style={{ borderTop: "1px solid #ddd" }}>
                        <th style={{ width: "50px" }}>Qty</th>
                        <th>Drink(s)</th>
                    </tr>
                    </thead>
                    <tbody style={{ borderTop: "1px solid #ddd" }}>
                    {Object.values(
                    orderItems
                        .filter(item => {
                        const isDrink = item.product.category === "Drinks";
                        // console.log("Filtering drinks items:", { item, isDrink });
                        return isDrink;
                        })
                        .reduce((acc, item) => {
                        // Group addOns by their group name
                        const groupedAddOns = item.product.addOns
                            ? item.product.addOns.reduce((groupAcc, addOn) => {
                                if (!groupAcc[addOn.group]) {
                                groupAcc[addOn.group] = [];
                                }
                                groupAcc[addOn.group].push(addOn.name);
                                return groupAcc;
                            }, {})
                            : {};

                        // Serialize grouped addOns for comparison
                        const addOnsKey = Object.entries(groupedAddOns)
                            .sort(([groupA], [groupB]) => groupA.localeCompare(groupB)) // Sort groups alphabetically
                            .map(([group, names]) => `${group}:${names.sort().join(",")}`) // Sort and join names in each group
                            .join("|"); // Join groups with "|"

                        // Generate a unique key based on product attributes
                        const key = `${item.product.name}__${item.remarks || "__no_remark__"}__${addOnsKey}`;
                        // console.log("Generated key:", { key, item });

                        if (!acc[key]) {
                            acc[key] = {
                            ...item,
                            quantity: item.quantity, // Start with the item's quantity
                            };
                        } else {
                            // Merge quantities
                            acc[key].quantity += item.quantity;
                        }
                        return acc;
                        }, {})
                    ).map((group, index) => (
                    <React.Fragment key={index}>
                        <tr>
                        <td style={{ width: "50px" }}>{group.quantity}</td>
                        <td>{group.product.name}</td>
                        <td style={{textAlign: "center"}}>[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;]</td>
                        {/* <td></td> */}
                        </tr>
                        {(group.remarks || (Array.isArray(group.product.addOns) && group.product.addOns.length > 0)) && (
                        <tr>
                            <td></td>
                            <td colSpan={2}>
                            <ul style={{ paddingLeft: "20px", margin: 0, listStyleType: "none", fontStyle: "italic" }}>
                                {Array.isArray(group.product.addOns) && group.product.addOns.length > 0 && (
                                Object.entries(
                                    group.product.addOns.reduce((acc, addOn) => {
                                    if (!acc[addOn.group]) {
                                        acc[addOn.group] = [];
                                    }
                                    acc[addOn.group].push(addOn.name);
                                    return acc;
                                    }, {})
                                ).map(([groupName, addOnGroup], idx) => (
                                    <li key={idx}>- {groupName}: {addOnGroup.join(", ")}</li>
                                ))
                                )}
                                {group.remarks && <li>- Remark: {group.remarks}</li>}
                            </ul>
                            </td>
                        </tr>
                        )}
                    </React.Fragment>
                    ))}
                    </tbody>
                    </>
                )}
                <tfoot>
                    <tr style={{ borderTop: "1px solid #ddd" }}>
                        <td>
                            <strong>
                                {/* {console.log(
                                    "Calculating total quantity:",
                                    orderItems.reduce((sum, item) => sum + item.quantity, 0)
                                )} */}
                                {orderItems.reduce((sum, item) => sum + item.quantity, 0)}
                            </strong>
                        </td>
                        <td style={{ textAlign: "left" }}>
                            <strong>Total</strong>
                        </td>
                        <td></td>
                    </tr>
                </tfoot>
            </table>                
            </div>

        </div>
    );
});

export default OrderReceipt;
